import React, { useEffect } from "react";
import ExtendedToast from "../alert/Toast";
import { wglcsApiService } from "../../services/WglcsApiService";
import "./Login/login.css";
import { Password } from "primereact/password";
import validator from "validator";
import history from "../../app/history";
import { utils } from "../../utils";
import { wgLogs } from "../../constants/wgLogs";
import { wgModules } from "../../models";
import { wgLogType } from "../../models/index";
import { DetectEnvironment } from "../../EnvironmentSettings";
import MainLogo from "./SignUpScreens/MainLogo";

const NewPassword: React.FC = ({ ...props }) => {
    const [password, setPassword] = React.useState<String>("");
    const [openSnackBar, setOpenSnackBar] = React.useState<Boolean>(false);
    const [confirmPassword, setConfirmPassword] = React.useState<String>("");
    const [check, setCheck] = React.useState<Number>(0);
    const [severity, setSeverity] = React.useState<String>("");
    const [responseMsg, setResponseMsg] = React.useState<String>("");
    const [newPasswordErrorText, setNewPasswordErrorText] = React.useState<String>("");
    const [reTypePasswordErrorText, setReTypePasswordErrorText] = React.useState<String>("");

    async function registerPassword() {
        var emailToken = utils.getQueryParameters().get("t") ?? "";

        emailToken = emailToken.replace(/-/g, '+').replace(/_/g, '/').replace(/ /g, '+')

        if (PasswordValidator()) {
            return;
        }

        const obj = {
            emailToken: emailToken,
            newPassword: password,
        };
        const response = await wglcsApiService.resetForgotPassword(obj);
        if (response?.data?.status) {
            // if (obj != null) wgLogs.saveLog(wgLogType.Update, wgModules.ResetPassword, "0", obj);
            setCheck(0);
            setSeverity("success")
            setResponseMsg("Password changed successfully")
            setOpenSnackBar(true);

            setTimeout(() => {
                setOpenSnackBar(false);
                history.push("/");
                window.location.reload();
            }, 2000);
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', onEnterBtn);
        return () => {
            window.removeEventListener('keydown', onEnterBtn);
        };
    }, [password, confirmPassword]);

    const onEnterBtn = (e) => {
        if (e.key?.toString() === 'Enter') {
            e.preventDefault()
            registerPassword()
        }
    }

    const PasswordValidator = () => {
        var isError = false;
        if (confirmPassword != "" && confirmPassword != password) {
            isError = true;
            setNewPasswordErrorText("Password don't match!")
        }
        if (
            validator.isStrongPassword(password, {
                minLength: 8,
                minUppercase: 1,
                minLowercase: 1,
                minNumbers: 1,
                minSymbols: 1,
                maxLength: 20,
            })
        ) {
        } else {
            isError = true;
            setNewPasswordErrorText("Password must have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character")
        }
        if (password == "") {
            isError = true;
            setNewPasswordErrorText("Please enter password!")
        }
        if (confirmPassword == "") {
            isError = true;
            setReTypePasswordErrorText("Please enter confirm password!")
        }

        return isError;
    };

    const header = <h6 style={{ fontSize: '16px' }}>Pick a password</h6>;
    const footer = (
        <React.Fragment>

            <p style={{ fontSize: '14px;', fontWeight: '700;' }} className="p-mt-1 mb-1 pt-0 pb-0">Suggestions</p>
            <ul className="p-pl-2 p-ml-2 p-mt-0 pb-0 mb-0" style={{ lineHeight: "1.2", fontSize: '12px;' }}>
                <li>At least one lowercase and uppercase</li>
                <li>At least one numeric and special character</li>
                <li>Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );

    return (
        <div className={DetectEnvironment.config.REACT_APP_BG_IMAGE_STYLE}>
            <div className="login-box">
                <MainLogo />

                <div className="login-head">
                    <h2>Reset Password</h2>
                </div>
                <div className="form-group">
                    <img className="login-input-image" title="Email" src={process.env.PUBLIC_URL + "/css/resources-images/ath.svg"} alt="" />
                    <Password placeholder="New Password" toggleMask onChange={(e) => setPassword(e.target.value)}
                        header={header}
                        footer={footer}
                    />
                    <span style={{ color: "red" }}>{newPasswordErrorText}</span>
                </div>
                <div className="form-group">
                    <img className="login-input-image" title="Email" src={process.env.PUBLIC_URL + "/css/resources-images/ath.svg"} alt="" />
                    <Password placeholder="Confirm Password" toggleMask onChange={(e) => setConfirmPassword(e.target.value)} />
                    {check === 1 ? (
                        <Password placeholder="Confirm Password" toggleMask onChange={(e) => setConfirmPassword(e.target.value)}
                            header={header}
                            footer={footer}
                        />

                    ) : null}
                    <span style={{ color: "red" }}>{reTypePasswordErrorText}</span>
                </div>

                <div className="form-group">
                    <button onClick={() => registerPassword()} className="signin-btn">
                        Submit
                    </button>
                </div>
            </div>
            <span className="copy-right">
                © {new Date().getFullYear()} {DetectEnvironment.config.REACT_APP_COPYRIGHT}
            </span>
            <ExtendedToast
                open={openSnackBar}
                severity={severity}
                handleClose={() => setOpenSnackBar(false)}
                message={responseMsg}
            />

        </div>
    );
};

export default NewPassword;
